import type { NativeStackScreenProps } from "@react-navigation/native-stack";
import { useTranslations } from "@src/packages/i18n";
import { useCoverage } from "../../../../../../packages/coverage/hooks/useCoverage";
import type { YouStackParamList } from "../../../types";
import CoverageBenefits from "../sections/CoverageBenefits";
import YouDetailScreenLayout from "../components/YouDetailScreenLayout";
import { useSmartBack } from "../../../hooks/useSmartBack";

type Props = NativeStackScreenProps<
  YouStackParamList,
  "CoverageBenefitsDetail"
>;

export default function CoverageBenefitsDetailScreen(_props: Props) {
  const handleBack = useSmartBack({
    fallbackTab: "Profile",
    fallbackScreen: "YouOverview",
  });
  const t = useTranslations();
  const {
    state: coverageState,
    policies,
    primaryPolicy,
    hasInsurance,
    verificationStatus,
    fertilityCoverage,
    isLoading,
    isError,
    refetch,
  } = useCoverage();

  return (
    <YouDetailScreenLayout
      title={t("you.panel_titles.coverage_benefits")}
      onBack={handleBack}
    >
      <CoverageBenefits
        policies={policies}
        primaryPolicy={primaryPolicy}
        hasInsurance={hasInsurance}
        coverageState={coverageState}
        verificationStatus={verificationStatus}
        fertilityCoverage={fertilityCoverage}
        isLoading={isLoading}
        isError={isError}
        onRetry={refetch}
      />
    </YouDetailScreenLayout>
  );
}
